import React from 'react'
import Layout from 'features/layout/components/Layout'
import Vod from '../components/Vod'

const VodPage = (props) => {
  return (
    <Layout>
      <Vod />
    </Layout>
  )
}

export default VodPage
